// Quotes (Craig, 28 Oct 2026; docs/specs/QUOTE.md): its own place in the menu, shown only while set-up has Connect's
// quotes part on (29 Oct 2026). Quotes sent, the price lists, the question flows and the assistant's knowledge.
// Screens are loaded with screen() (see ./screen.ts), never imported directly.
import type { FlatModule } from "./types";
import { screen } from "./screen";

const PriceBooksPage = screen(() => import("../screens/quote/PriceBooks"), "PriceBooksPage");
const QuestionFlowsPage = screen(() => import("../screens/quote/QuestionFlows"), "QuestionFlowsPage");
const KnowledgePage = screen(() => import("../screens/quote/Knowledge"), "KnowledgePage");
const QuotesPage = screen(() => import("../screens/quote/Quotes"), "QuotesPage");

/** The set-up part that puts Quotes in the menu. */
export const QUOTES_PART = "connect.quotes";

export const quotes: FlatModule = {
  key: "quotes",
  label: "Quotes",
  layout: "flat",
  shownWithPart: QUOTES_PART,
  items: [
    { path: "/quotes", label: "Quotes", step: "9.17", render: () => <QuotesPage /> },
    { path: "/quotes/price-lists", label: "Price lists", step: "9.16", render: () => <PriceBooksPage /> },
    { path: "/quotes/flows", label: "Question flows", step: "9.16", render: () => <QuestionFlowsPage /> },
    { path: "/quotes/knowledge", label: "Knowledge", step: "9.16", render: () => <KnowledgePage /> },
  ],
  taskHomes: {
    // Ogma Quote (9.5, 9.16, 9.17, 9.19): quotes to prepare and approve, answers to check, and what the customer did.
    approve_quote: ["/quotes"],
    confirm_quote_answers: ["/quotes"],
    prepare_quote: ["/quotes"],
    quote_outcome: ["/quotes"],
    // 9.27 a customer answered a flow on the quote portal and waits to hear back
    portal_answers: ["/quotes"],
    // 9.28 the quote assistant passed a customer's question on: answered into the knowledge
    portal_question: ["/quotes/knowledge"],
  },
};
